module.exports = __webpack_public_path__ + "img/77-78.4c2e45f3.jpg";